export const SHOW_MAGIC_LINK_MODAL = 'SHOW_MAGIC_LINK_MODAL';
export const ENABLE_MAGIC_LINK_BUTTON = 'ENABLE_MAGIC_LINK_BUTTON';
